import DOMPurify from 'dompurify'

/**
 * Controller class for the simple modal.
 *
 * @class SimpleModalController
 */
export default class SimpleModalController {
  constructor($sce, close, options) {
    'ngInject'
    this.close = close
    this.options = options
    const sanitizedContent = DOMPurify.sanitize(options.content)
    this.content = $sce.trustAsHtml(sanitizedContent)
  }
}
